module.exports = __webpack_public_path__ + "static/img/hua9.6f6a2d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua9.png
// module id = AMzP
// module chunks = 22